import api from './api'

const searchObjectBasePath = '/api/v1/fund-map/search-object'

export async function getAllSearchObjects() {
  const resp = await api.get(`${searchObjectBasePath}`)
  return resp.data
}

export async function getSearchObjectsById(searchObjectId) {
  const resp = await api.get(`${searchObjectBasePath}?id=${searchObjectId}`)
  return resp.data
}

export async function getSearchObjectsByUserId(userId) {
  const resp = await api.get(`${searchObjectBasePath}/${userId}`, userId)
  return resp.data
}

export async function saveSearchObjects(saveData) {
  const resp = await api.post(`${searchObjectBasePath}`, saveData)
  return resp.data
}

export async function patchSearchObjectsById(searchObjectId, searchObject) {
  const resp = await api.patch(`${searchObjectBasePath}/${searchObjectId}`, searchObject)
  return resp.data
}

export async function deleteSearchObjectsById(searchObjectId) {
  const resp = await api.delete(`${searchObjectBasePath}/${searchObjectId}`, searchObjectId)
  return resp.data
}
